import { MLSListing } from "../types/MLSListing";

const mlsFormatDetailList = ( keys: Array<string>, listing: MLSListing, prefix: string = '' ): string => {
    const values: Array<string> = [];
    keys.forEach( ( key: string ) => {
        // Check the binary value of each key
        if ( listing[ key ] && listing[ key ] === '1' ) {
            // Transform the key into a label
            // Replace the prefix
            let label: string = key.replace( prefix, '' );
            // Add spaces between capitalized words
            label = label.replace( /([A-Z])+/, ' $1' );
            // Add the label to $values
            values.push( label.trim() );
        }
    } );
    return values.length ? values.join( ', ' ) : '---';
}

export default mlsFormatDetailList;